import React from "react";
import { Bar, BarChart, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#00bcd4"];
const EmotionalLevelBarChart = ({ data }) => {

    const CustomYAxisTick = ({ x, y, payload }) => {
        const entry = data[payload.index];
        const textColor =
            entry.name === "Happy"
                ? "#4caf50"
                : entry.name === "Sad"
                    ? "#2196f3"
                    : entry.name === "Angry"
                        ? "#f44336"
                        : "#9c27b0";

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={4}
                    textAnchor="end"
                    fill={textColor}
                    fontSize={12}
                    fontWeight={500}
                >
                    {`${entry.name} (${entry.emotion})`}
                </text>
            </g>
        );
    };

    const render = () => {
        if (data && data.length)
            return (
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        layout="vertical"
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 25,
                        }}
                    >
                        <XAxis dataKey="value"
                            type="number" label={
                                {
                                    value: 'Shows which levels are more prevlent',
                                    position: 'outsideBottom',
                                    dy: 25,
                                    fill: '#888',
                                    fontSize: 12
                                }} />
                        <YAxis dataKey="name" type="category" fontSize={10} tickFormatter={(name, index) => {
                            const entry = data[index];
                            return `${name} (${entry.emotion})`;
                        }} />
                        <Tooltip />
                        <Bar dataKey="value" barSize={22}>
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>);

        return <p className="p-0 m-0 d-flex align-items-center justify-content-center">Loading...</p>;
    }
    return render();
}

export default EmotionalLevelBarChart